<template>
  <el-dialog
    title="详情"
    v-if="dialogVisible"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="60%"
    class="dialog"
    center
  >
    <div class="auto-table-flex">
      <el-table
        :data="tableData"
        height="300"
        :border="true"
        tooltip-effect="dark"
        :header-cell-style="{ color: '#333333', background: '#EFF6FF' }"
      >
        <el-table-column
          prop="sku_code"
          width="100px"
          align="center"
          label="货号"
        >
        </el-table-column>
        <el-table-column prop="supplier_name" align="center" label="供应商名称">
        </el-table-column>
        <el-table-column prop="create_time" align="center" label="添加时间">
        </el-table-column>
        <el-table-column prop="owner_name" align="center" label="添加人">
        </el-table-column>
        <el-table-column prop="quantity" align="center" label="件数">
        </el-table-column>
        <el-table-column prop="deduction_amt" align="center" label="扣款金额">
        </el-table-column>
        <el-table-column prop="video_list" align="center" label="视频证据">
          <template slot-scope="scope">
            <span
              @click="onHandleShow(scope.row)"
              style="color: #1389ae"
              class="pointer font-weight"
              >查看证据</span
            >
          </template>
        </el-table-column>
        <el-table-column prop="qc_type_line" align="center" label="问题原因">
        </el-table-column>
        <el-table-column
          prop="remarks"
          align="center"
          label="缺少斤数*毛单价"
          min-width="150"
        >
          <template slot-scope="scope">
            {{ scope.row.weight }}*{{ scope.row.weight_price }}
          </template>
        </el-table-column>
        <el-table-column prop="remarks" align="center" label="备注" width="300">
        </el-table-column>
      </el-table>
    </div>
    <div class="fy">
      <el-pagination
        type="primary"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="from.pageSize"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="from.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
       <!-- 文件预览 start -->
    <c-preview-file
      v-model="dialogVisible1"
      :fileList="fileList"
      :fileIndex="previewIndex"
      :fileType="fileType"
    ></c-preview-file>
    <!-- 文件预览 end -->
  </el-dialog>
</template>

<script>
import CPreviewFile from "@/components/common/CPreviewFile/index.vue";
export default {
  name: "TableList",
  components: {CPreviewFile},
  data() {
    return {
      dialogVisible: false,
      dialogVisible1: false,
      tableData: [],
      loading: false,
      currentPage: 0,
      total: 0,
      from: {
        sku_code: "", //	T文本	是	排序方式
        page: 1,
        pageSize: 50,
      },
        fileList: [], // 预览文件列表
      previewIndex: 0, //预览文件下标
      fileType: "", // 预览文件类型
    };
  },
      computed: {
    /**
     * 获取文件类型
     */
    getFileType() {
      return (file) => {
        const extIndex = file.url.lastIndexOf(".");
        const fileType = file.url.slice(extIndex + 1).toLocaleLowerCase();
        return fileType;
      };
    },
  },
  methods: {
    oninit(e) {
      this.from.sku_code = e.sku_code;
      this.dialogVisible = true;
      this.hqlist();
    },

    hqlist() {
      this.$api.product.controllist(this.from).then((res) => {
        console.log(res);
        this.tableData = res.data.data;
        this.total = res.data.total;
      });
    },
    handleSizeChange(val) {
      //   console.log(`每页 ${val} 条`);
      this.from.pageSize = val;
      this.hqlist();
    },
    handleCurrentChange(val) {
      this.from.page = val;
      this.hqlist();
    },
      /** 查看证据 文件预览 */
    onHandleShow(row) {
      let tmpVideoList = [];
      if (row.video_list.length > 0) {
        row.video_list.map((vItem) => {
          tmpVideoList.push({
            label: "视频",
            url: vItem,
          });
        });
      }
      let tmpImageList = [];
      if (row.image_list.length > 0) {
        row.image_list.map((mItem) => {
          tmpImageList.push({
            label: "图片",
            url: mItem,
          });
        });
      }
      this.fileList = tmpVideoList.concat(tmpImageList);
      console.log(this.fileList, "----");
      this.dialogVisible1 = true;
      this.fileType = this.getFileType(this.fileList[0]);
    },
  },
};
</script>
<style lang="scss" scoped></style>
